
import Vue from "vue"
import Component from "vue-class-component"
import {Model, Prop} from "vue-property-decorator"
import {dimensionsAsOptions} from "@/ui/cubeOptions"
import {Option} from "@/ui/Option"
import {Dimension} from "@/cube"
import OptionSelect from "@/ui/OptionSelect.vue"

@Component({components: {OptionSelect}})
export default class DimensionSelect extends Vue {
  @Model("input")
  selected: Array<Dimension> | Dimension

  @Prop({default: false})
  mountOpened: boolean

  options: ReadonlyArray<Option> = []

  ready = false

  async created() {
    this.options = await dimensionsAsOptions()
    this.ready = true

    if (this.mountOpened) {
      await this.$nextTick()
      const inputEl = <HTMLElement>this.$el.querySelector(".multiselect__input")
      inputEl.focus()
    }
  }

  setSelected(value: any) {
    this.$emit("input", value)
  }
}
